// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserUsageCard_main__4-JWy {
    display: flex;
    flex-wrap: wrap;
}

.UserUsageCard_card__e48BN {
    width: 200px;
    margin-right: 20px;
    margin-bottom: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/UserUsageCard/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".main {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.card {\n    width: 200px;\n    margin-right: 20px;\n    margin-bottom: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `UserUsageCard_main__4-JWy`,
	"card": `UserUsageCard_card__e48BN`
};
export default ___CSS_LOADER_EXPORT___;
